import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { SinisterTrendPoint } from "../../api/dashboard";
import { useTranslation } from "react-i18next";

type Props = { data: SinisterTrendPoint[] };

/** Monthly claims trend (Nektia "Momentum" style) — gradient area chart. */
export const ClaimsTrendChart: React.FC<Props> = ({ data }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const stroke = theme.palette.primary.main;

  return (
    <Box sx={{ width: "100%", height: 240 }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 8, right: 8, left: -16, bottom: 0 }}>
          <defs>
            <linearGradient id="claimsFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={stroke} stopOpacity={0.35} />
              <stop offset="100%" stopColor={stroke} stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.divider} vertical={false} />
          <XAxis
            dataKey="month"
            tick={{ fill: theme.palette.text.secondary, fontSize: 12 }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            allowDecimals={false}
            tick={{ fill: theme.palette.text.secondary, fontSize: 12 }}
            axisLine={false}
            tickLine={false}
            width={36}
          />
          <Tooltip
            contentStyle={{
              background: theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: 10,
              fontSize: 12,
              color: theme.palette.text.primary,
            }}
            labelStyle={{ color: theme.palette.text.secondary }}
          />
          <Area
            type="monotone"
            dataKey="count"
            name={t("panel.claims.claims", "Claims")}
            stroke={stroke}
            strokeWidth={2.5}
            fill="url(#claimsFill)"
            dot={{ r: 3, fill: stroke, strokeWidth: 0 }}
            activeDot={{ r: 5 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  );
};
